export default () => ({
  ctaVideoModal: false,
  play: false,
  init() {
    this.$watch('play', (value) => {
      if (value) {
        this.checkVideo()
      } else {
        this.$refs.video.pause()
      }
    })
  },
  checkVideo() {
    //Every 200ms, check if the video element has loaded
    var b = setInterval(() => {
      if (this.$refs.video.readyState >= 3) {
        //This block of code is triggered when the video is loaded

        //your code goes here
        this.$refs.video.play()

        //stop checking every half second
        clearInterval(b);

      }
    }, 200);
  }
});
